(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqDeleteController',CategoryIbqDeleteController);

    CategoryIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Category'];

    function CategoryIbqDeleteController($uibModalInstance, entity, Category) {
        var vm = this;

        vm.category = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Category.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
